<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { slaughterDtoFields } from "../../utils/TableFields/slaughter-dto.fields";
  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    search,
    onDateFilterChanged,
    assignLotNumbers,
    downloadDailySlaughterReport,
    downloadDestinazioneCarcasseReport,
  } from "./butcher-slaughter.store";
  import DateInputString from "../../components/Form/Fields/DateInputString.svelte";
  import Button from "../../components/Button.svelte";
  import { isUserRoleADM } from "../../app.store";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="macellazione"
    entityPlural="macellazioni"
    searchFieldVisible={false}
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
    <div slot="search" class="level-item weight-label-search-box">
      <div style="min-width: 5rem;">
        <DateInputString name="" placeholder="Data Macellazione" required={false} value={$filter.criteria.refDate} on:select={onDateFilterChanged} />
      </div>
      <p class="control" style="margin-left:1rem;">
        <Button klass="is-warning" on:click={assignLotNumbers}>
          <span>Assegna lotti</span>
        </Button>
      </p>

      {#if $isUserRoleADM}
        <p class="control" style="margin-left:1rem;">
          <Button klass="is-clear" on:click={downloadDailySlaughterReport}>
            <span>Stampa programmazione</span>
          </Button>
        </p>

        <p class="control" style="margin-left:1rem;">
          <Button klass="is-clear" on:click={downloadDestinazioneCarcasseReport}>
            <span>Stampa destinazione carcasse</span>
          </Button>
        </p>
      {/if}
    </div>

    <!-- TEMPORARILY DISABLED
    <div slot="additional" class="level-right">
      <div class="level-item">
        <ButcherPageSwitch currentPage={ButcherPage.Slaughter}></ButcherPageSwitch>
      </div>
    </div>
    -->
  </SearchHeader>

  <Table
    loading={$loading}
    fields={slaughterDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={$isUserRoleADM}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
